<template>

  <div v-if="!firestoreReady" class="row justify-center" style="margin-top: 40px">
    <h2>Submind.</h2>
    <q-inner-loading :showing="true">
      <q-spinner-grid size="50%" color="primary"></q-spinner-grid>
    </q-inner-loading>
  </div>

  <q-layout v-else view="hHh Lpr lFf">
    <q-header v-model="showHeader" class="shadow-1">
      <q-toolbar class="bg-primary text-white">
        <q-btn
          flat
          dense
          round
          @click="treeViewOpen = !treeViewOpen"
          aria-label="Menu"
          v-if="!treeDisabled">
          <q-icon name="mdi-file-tree" />
        </q-btn>

        <q-toolbar-title @click.native="$router.push('/')" style="cursor: pointer;">
          Submind.
          <small>+Coders Notes</small>
        </q-toolbar-title>
        <!--<q-chip round color="primary" icon="mdi-wifi-off" v-if="!onlineStatus">-->
          <!--Offline-->
        <!--</q-chip>-->

        <q-btn-dropdown
          color="primary"
          :label="session.name || ''">
          <q-list link>
            <q-item v-for="(sess, i) in userSessions" :key="i"
                    v-close-popup clickable @click.native="setSessionIndex(i)">
              <q-item-section>
                <q-item-label>{{sess.name}}</q-item-label>
              </q-item-section>
              <q-btn flat dense round icon="delete" color="red" @click.native="deleteSession(sess, i, $event)" ></q-btn>
            </q-item>
            <q-separator></q-separator>
            <q-item v-close-popup clickable @click.native="newSession">
              <q-item-section side >
                <q-icon name="mdi-plus"></q-icon>
              </q-item-section>
              <q-item-section>
                <q-item-label>New Session</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
        <q-btn
          flat
          dense
          round
          @click="rightDrawerOpen = !rightDrawerOpen"
          aria-label="Menu">
          <q-icon name="mdi-settings" />
        </q-btn>
      </q-toolbar>
    </q-header>

    <q-drawer
      no-hide-on-route-change
      v-model="showTreeView"
      content-class="bg-grey-1">
      <div class="column" style="height: 100%;" >
        <q-toolbar v-show="!showSpaces" class="bg-primary text-white">
<!--          <q-btn flat dense round icon="mdi-plus" @click="newNote" />-->
          <q-btn flat dense round icon="subdirectory_arrow_right" @click="newSubNote(selectedTreeItemId)">
            <q-tooltip :offset="[0, 10]">Create Subnote</q-tooltip>
          </q-btn>
<!--          <q-btn flat dense round icon="transform" @click="reorderNotes" />-->
          <q-btn flat dense round icon="delete" style="float: right;" @click="deleteNote(selectedTreeItemId)">
            <q-tooltip :offset="[0, 10]">Delete Note</q-tooltip>
          </q-btn>
          <q-btn flat dense round icon="mdi-target" style="float: right;" @click="scrollToSelectedNote()">
            <q-tooltip :offset="[0, 10]">Focus Open Note In Tree</q-tooltip>
          </q-btn>
          <!--<q-btn flat dense round icon="delete" style="float: right;" @click="deleteNote(selectedTreeItemId)"/>-->
        </q-toolbar>
        <div style="padding-left: 5px; padding-right: 5px;" class="col column" v-show="!showSpaces">
          <note-context-menu :item-id="contextItemId" />
          <div>
            <q-input dense v-model="filter" label="Filter Tree" class="col" style="margin-bottom: 5px; padding-bottom: 2px;"></q-input>
          </div>
          <div class="col">
            <q-scroll-area style="width: 100%; height: 100%">
              <div @contextmenu="rightClickHandler($event)">
                <q-tree
                  :nodes="items"
                  node-key="id"
                  :filter="filter"
                  :filter-method="filterMethod"
                  :expanded.sync="expandedTreeItemIds"
                  :selected.sync="selectedTreeItemId"
                  @dblclick.native="toggleItem($event)">
                  <div slot="default-header" slot-scope="prop">
                    <q-icon v-if="prop.node.icon" :name="prop.node.icon" size="20px" class="q-mr-sm" :color="prop.node.iconColor || undefined"></q-icon>
                    <span :id="'nodeId_' + prop.node.id" class="non-selectable">{{ prop.node.label }}</span>
                  </div>
                </q-tree>
              </div>
            </q-scroll-area>
          </div>
        </div>
<!--        <div style="padding-left: 5px; padding-right: 5px;" class="col column" v-show="showSpaces">-->
<!--          <div>-->
<!--            <q-input v-model="filter" float-label="Search Spaces" class="col" style="margin-bottom: 5px; padding-bottom: 2px;"></q-input>-->
<!--          </div>-->
<!--          <div class="col">-->
<!--            <q-menu touch-position-->
<!--                    context-menu-->
<!--                    ref="context">-->
<!--              <div class="q-pa-sm" style="text-align: center; padding-bottom: 0;">{{(contextItemNoteHelper || {}).name}}</div>-->
<!--              <q-list link separator no-border-->
<!--                      style="min-width: 150px; max-height: 300px;">-->
<!--                <q-item v-close-popup @click.native="moveItemTo" v-if="moveFromNoteHelper && moveFromNoteHelper !== contextItemNoteHelper">-->
<!--                  <q-item-section>-->
<!--                    {{'Move \'' + moveFromNoteHelper.name + '\' To Here'}}-->
<!--                  </q-item-section>-->
<!--                </q-item>-->
<!--                <q-item v-close-popup @click.native="moveItemFrom">-->
<!--                  <q-item-section>Move</q-item-section>-->
<!--                </q-item>-->
<!--                <q-item v-close-popup @click.native="moveItemToRoot">-->
<!--                  <q-item-section>Move To Top Level</q-item-section>-->
<!--                </q-item>-->
<!--                <q-item v-close-popup @click.native="newSubNote(contextItemId)">-->
<!--                  <q-item-section>Add Child</q-item-section>-->
<!--                </q-item>-->
<!--                <q-item v-close-popup @click.native="deleteNote(contextItemId)">-->
<!--                  <q-item-section>Delete</q-item-section>-->
<!--                </q-item>-->
<!--                <q-item v-close-popup @click.native="setRootNote(contextItemId)">-->
<!--                  <q-item-section>Make Root</q-item-section>-->
<!--                </q-item>-->
<!--              </q-list>-->
<!--            </q-menu>-->
<!--            <q-scroll-area style="width: 100%; height: 100%">-->
<!--              <div @contextmenu="rightClickHandler($event)">-->
<!--                <q-list highlight>-->
<!--                  <q-item-label header>Recent chats</q-item-label>-->
<!--                  <q-item>-->
<!--                    <q-item-section label="John Doe" />-->
<!--                    <q-item-section side right>-->
<!--                      <q-item-label icon="chat_bubble" color="green" />-->
<!--                    </q-item-section>-->
<!--                  </q-item>-->
<!--                  <q-item>-->
<!--                    <q-item-section label="Jim Doe" />-->
<!--                    <q-item-section side right icon="chat_bubble" />-->
<!--                  </q-item>-->
<!--                  <q-separator />-->
<!--                  <q-item-label header>Previous chats</q-item-label>-->
<!--                  <q-item>-->
<!--                    <q-item-section label="Jack Doe" />-->
<!--                  </q-item>-->
<!--                </q-list>-->
<!--              </div>-->
<!--            </q-scroll-area>-->
<!--          </div>-->
<!--        </div>-->
        <!--<q-toolbar style="height: 20px; min-height: 20px; text-align: center;" v-show="!showSpaces">-->
          <!--<q-toolbar-title @click.native="toggleSpaces">-->
            <!--<span slot="subtitle">Spaces</span>-->
          <!--</q-toolbar-title>-->
        <!--</q-toolbar>-->
      </div>
    </q-drawer>

    <q-drawer
      side="right"
      v-model="rightDrawerOpen"
      overlay
      :no-swipe-open="!$q.platform.is.mobile"
      :no-swipe-close="!$q.platform.is.mobile"
      content-class="bg-grey-2"
      behavior="mobile" >

      <q-card square class="q-pt-sm shadow-2">
        <q-item>
          <q-item-section side>
            <q-avatar>
              <img :src="currentUser.photoURL || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfNLrA4MhND_BlfRAqE2gustOyW74DWoHQx-4ygBAQdgoI0VBrlg'">
            </q-avatar>
          </q-item-section>
          <q-item-section>
            <q-item-label>{{currentUser.displayName}}</q-item-label>
            <q-item-label caption>{{firebaseUser.email}}</q-item-label>
          </q-item-section>
        </q-item>
      </q-card>

      <q-list
        no-border
        link
        inset-delimiter >
        <q-item clickable v-ripple @click.native="$router.push('/components')">
          <q-item-section avatar>
            <q-icon name="code" />
          </q-item-section>
          <q-item-section>Components</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click.native="$router.push('/noteTemplates')">
          <q-item-section avatar>
            <q-icon name="extension" />
          </q-item-section>
          <q-item-section>Note Templates</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click.native="showSettings">
          <q-item-section avatar>
            <q-icon name="tune" />
          </q-item-section>
          <q-item-section>All Settings</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click.native="$router.push('/docs/home')">
          <q-item-section avatar>
            <q-icon name="bookmark" />
          </q-item-section>
          <q-item-section>Documentation</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click.native="exportData">
          <q-item-section avatar>
            <q-icon name="cloud_download" />
          </q-item-section>
          <q-item-section>Export data</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click.native="askLogout">
          <q-item-section avatar>
            <q-icon name="exit_to_app" />
          </q-item-section>
          <q-item-section>Log Out</q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view ref="page"/>
    </q-page-container>

    <search-modal />
    <settings-modal />
    <reorder-modal />
    <choose-template-modal ref="chooseTemplateModal" />
  </q-layout>
</template>

<script>
import { openURL } from 'quasar'
import firebase from 'firebase/app'
import 'firebase/auth'
import SearchModal from '../components/SearchModal'
import SettingsModal from '../components/SettingsModal'
import ReorderModal from '../components/ReorderModal'
import ChooseTemplateModal from '../components/ChooseTemplateModal'
import { createNewNote, findNoteHelper } from '../js/noteTemplates/noteHelpers'
import * as Mousetrap from 'mousetrap'
import NoteContextMenu from '../components/NoteContextMenu'
import {
  collapseNoteIdInTree, expandNoteIdInTree,
  renameCurrentSession,
  setCurrentSessionIndex,
  updateCurrentSession
} from '../js/noteTemplates/sessionsHelper'
import { navigateToNote, newSubNote } from '../js/noteTemplates/noteUiHelpers'
import { chooseSessionWithDialog } from '../js/noteTemplates/sessionsUiHelper'

export default {
  name: 'LayoutDefault',
  components: {
    NoteContextMenu,
    'search-modal': SearchModal,
    'settings-modal': SettingsModal,
    'reorder-modal': ReorderModal,
    'choose-template-modal': ChooseTemplateModal
  },
  data () {
    return {
      rightDrawerOpen: false,
      treeViewOpen: true,
      filter: '',
      lastSearchFilter: '',
      enableContextMenu: false,
      contextItemId: null,
      contextItemNoteHelper: null,
      moveFromNoteHelper: null,
      showSpaces: false,
      expandedTreeItemIdsDuringSearch: []
    }
  },
  computed: {
    session () {
      return this.$store.getters.currentSession
    },
    expandedTreeItemIds: {
      get () {
        return this.filter
          ? this.expandedTreeItemIdsDuringSearch
          : this.session.expandedTreeNoteIds
      },
      set (expandedTreeNoteIds) {
        return updateCurrentSession({ expandedTreeNoteIds })
      }
    },
    userSessions () {
      return this.$store.getters.userSessions
    },
    showTreeView: {
      get () {
        return this.treeViewOpen && !this.treeDisabled
      },
      set (val) {
        this.treeViewOpen = val
      }
    },
    treeDisabled () {
      return this.distractionFreeMode || this.$route.path.startsWith('/components/')
    },
    showHeader () {
      return !this.distractionFreeMode
    },
    selectedTreeItemId: {
      get () { return this.$route.params.id || null },
      set (noteId) {
        navigateToNote(noteId)
        // return _setSelectedTreeItemId(noteId)
      }
    },
    firestoreReady () { return this.$store.state.ui.firestoreReady },
    currentUser () { return this.$store.state.auth.currentUser },
    firebaseUser () { return firebase.auth().currentUser },
    distractionFreeMode () { return this.$store.state.ui.distractionFreeMode },
    // ...mapGetters({items: 'getItemTree'})
    items () {
      return this.$store.state.items.navTree
    },
    isEditingAllowed () {
      return this.$store.getters.isEditingAllowed
    },
    onlineStatus () {
      return this.$store.state.ui.onlineStatus
    },
    offlinePersistenceEnabled () {
      return this.$store.state.ui.offlinePersistenceEnabled
    }
  },
  methods: {
    openURL,
    newSubNote (id) {
      return newSubNote(id)
    },
    filterMethod (node, filter) {
      if (filter === this.lastSearchFilter);
      if (filter === '') this.expandedTreeItemIdsDuringSearch = []
      const filt = filter.toLowerCase()
      const title = node.label
      const content = this.$store.state.items.items[node.id].data
      const userData = this.$store.state.items.items[node.id].userData
      const expanded = (title && title.toLowerCase().indexOf(filt) > -1) ||
                       (content && content.toLowerCase().indexOf(filt) > -1) ||
                       (filter in userData) // Hacky, just searching for keys for now

      // this.expandedTreeItemIds.push(node.id)
      this.expandedTreeItemIdsDuringSearch.push(node.id)
      return expanded
    },
    askLogout () {
      this.$q.dialog({
        title: 'Logout',
        message: 'Are you sure you want to log out?',
        ok: true,
        cancel: true
      }).onOk(() => {
        this.logout()
      })
    },
    logout () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/')
        this.rightDrawerOpen = false
      })
    },
    exportData () {
      const data = {
        user: this.$store.state.auth.currentUser,
        notes: this.$store.state.items.items,
        noteTemplates: this.$store.state.noteTemplates.noteTemplates,
        components: this.$store.state.components.components
      }

      this.downloadObjectAsJson(data, `submind-export-${this.$store.state.auth.currentUser.uid}`)
    },
    downloadObjectAsJson (exportObj, exportName) {
      const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportObj, undefined, 2))
      const downloadAnchorNode = document.createElement('a')
      downloadAnchorNode.setAttribute('href', dataStr)
      downloadAnchorNode.setAttribute('download', exportName + '.json')
      document.body.appendChild(downloadAnchorNode) // required for firefox
      downloadAnchorNode.click()
      downloadAnchorNode.remove()
    },
    newNote () {
      let newItem = { data: '# New note\nAdd some text...', userData: {}, children: [] }
      createNewNote(newItem)

      // todo: highlight title!!

      // this.$store.dispatch('addItem', {item: newItem, parentItemId: null}).then((newId) => {
      //   this.$router.push('/home/' + newId, (a) => {
      //     console.log(a)
      //     console.log(this)
      //   })
      // })
    },
    setRootNote (noteId) {
      return updateCurrentSession({ rootNoteId: noteId })
      // let sessionClone = Object.assign({}, this.session)
      // sessionClone.rootNoteId = noteId
      // this.$store.dispatch('updateUserSession', {
      //   index: this.$store.state.ui.currentSessionIndex,
      //   session: sessionClone
      // })
    },
    deleteNote (noteId) {
      this.enableContextMenu = false
      const noteHelper = findNoteHelper(noteId)
      this.$q.dialog({
        title: 'Delete note \'' + noteHelper.name + '\'?',
        message: 'Are you sure you want to delete this note?',
        // position: 'top',
        ok: 'Delete It',
        cancel: 'Cancel'
      }).onOk(() => {
        // They confirmed the deletion!
        // this.$router.replace('/home')
        return this.$store.dispatch('deleteItemWithId', noteId)
      })
    },
    scrollToSelectedNote () {
      const nodeid = 'nodeId_' + this.selectedTreeItemId
      let nh = findNoteHelper(this.selectedTreeItemId)
      // Expand all parents
      while (nh && nh.parent.noteId !== this.session.rootNoteId) {
        nh = nh.parent
        if (this.filter && !(this.expandedTreeItemIdsDuringSearch.includes(nh.noteId))) {
          this.expandedTreeItemIdsDuringSearch.push(nh.noteId)
        } else if (!this.filter && !(this.expandedTreeItemIds.includes(nh.noteId))) {
          this.expandedTreeItemIds.push(nh.noteId)
        }
      }
      this.$nextTick(() => {
        const treeItemEl = document.getElementById(nodeid)
        treeItemEl.scrollIntoView()
      })
    },
    showSettings () {
      this.$store.dispatch('openSettingsDialog', '')
    },
    reorderNotes () {
      this.$store.dispatch('openReorderModal', this.$store.state.items.selectedTreeItemId)
    },
    rightClickHandler (e) {
      e.preventDefault()
      const targetId = this.getNodeIdFromElement(e.target)
      // console.log('context menu: ' + targetId)

      if (targetId != null) {
        this.contextItemId = targetId
        // this.contextItemNoteHelper = findNoteHelper(this.contextItemId)
        // if (!this.contextItemNoteHelper) {
        //   this.contextItemId = null
        //   this.contextItemNoteHelper = null
        //   return
        // }
        // if (this.$refs.context.show) this.$refs.context.show()
        // else if (this.$refs.context.__show) this.$refs.context.__show()
        // else console.error('Context show failed')
        // console.log('context menu: ' + this.contextItemNoteHelper.name)
      } else {
        e.stopPropagation()
      }
    },
    toggleItem (event) {
      const id = this.getNodeIdFromElement(event.target)
      const index = this.expandedTreeItemIds.indexOf(id)
      if (index >= 0) {
        collapseNoteIdInTree(id)
        // this.expandedTreeItemIds.splice(index, 1)
      } else {
        expandNoteIdInTree(id)
        // this.expandedTreeItemIds.push(id)
      }
    },
    getNodeIdFromElement (element) {
      if (element.id.startsWith('nodeId_')) {
        return element.id.substr(7)
      } else {
        try {
          let rowElement
          if (element.classList.contains('row')) {
            rowElement = element
          } else {
            rowElement = element.getElementsByClassName('row')[0]
          }
          return rowElement.children[0].children[0].id.substr(7)
        } catch {
          return null
        }
      }
    },
    moveItemToRoot () {
      this.contextItemNoteHelper.parent = null
    },
    newSession () {
      this.$q.dialog({
        title: 'New Session',
        message: 'Enter the name of the new session',
        prompt: {
          model: '',
          type: 'text' // optional
        },
        cancel: true,
        color: 'secondary'
      }).onOk(data => {
        return this.$store.dispatch('addUserSession', {
          name: data,
          expandedTreeNoteIds: [],
          rootNoteId: null,
          spaceId: null
        })
      }).then((newSessionIndex) => {
        setCurrentSessionIndex(newSessionIndex)
      }).catch(() => {
        this.$q.notify('Session was not created.')
      })
    },
    renameSession () {
      let session = this.session
      this.$q.dialog({
        title: 'Rename Session',
        message: 'Enter a new name for this session.',
        prompt: {
          model: session.name,
          type: 'text' // optional
        },
        cancel: true,
        color: 'secondary'
      }).onOk(newName => {
        return renameCurrentSession(newName)
      }).catch(() => {
        this.$q.notify('Session name was not updated.')
      })
    },
    deleteSession (session, sessionIndex, event) {
      event.preventDefault()
      let sessionName = session.name
      // let session = this.$store.state.auth.currentUser.sessions[sessionIndex]
      this.$q.dialog({
        title: 'Delete Session',
        message: 'Are you sure you want to delete the session \'' + sessionName + '\'?',
        ok: 'Delete',
        cancel: 'Cancel'
      }).onOk(() => {
        return this.$store.dispatch('deleteUserSession', sessionIndex)
      }).then(() => {
        setCurrentSessionIndex(0)
        this.$q.notify({
          message: 'Session ' + sessionName + ' was deleted.',
          type: 'positive'
        })
      }).catch(() => {
        this.$q.notify('Session ' + session.name + ' was not deleted.')
      })
    },
    toggleSpaces () {
      this.showSpaces = !this.showSpaces
    },
    setSessionIndex (index) {
      setCurrentSessionIndex(index)
    }
  },
  mounted () {
    Mousetrap.bind(['ctrl+shift+s'], () => {
      chooseSessionWithDialog()

      // return false to prevent default browser behavior
      // and stop event from bubbling
      return false
    })
    Mousetrap.bind(['ctrl+shift+f', 'command+shift+f'], () => {
      console.log('command shift f')
      this.$store.dispatch('openSearchDialog', '')
      // return false to prevent default browser behavior
      // and stop event from bubbling
      return false
    })
  }
}
</script>

<style>
</style>
